import { useViewport } from 'contexts/viewport';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button, Container, Stack, styled, Text } from 'shell/components';

const ErrorPage = () => {
    const history = useHistory();
    const { device } = useViewport();
    const { t } = useTranslation();

    return (
        <Container device={device}>
            <Stack alignItems={'center'} spacing={4}>
                <Text align={'center'} color={'light'} variant={'h6'} weight={'semibold'}>
                    {t('not-found.description', "The page you are looking for couldn't be found.")}
                </Text>
                <Button align={'center'} variant={'borderless'} onClick={() => history.push('/')}>
                    {t('not-found.back-to-home', 'Back to Home')}
                </Button>
            </Stack>
            <CustomText>
                {t('not-found.debug', 'Debug: {{debug}}', { debug: process.env.REACT_APP_GIT_TAG })}
            </CustomText>
        </Container>
    );
};

const CustomText = styled(Text)(({ theme }) => {
    return {
        position: 'absolute',
        bottom: theme.spacing(1),
        right: theme.spacing(1),
    };
});

export default ErrorPage;
